import Phaser from 'phaser';

export abstract class GameObject extends Phaser.GameObjects.Container {
  protected health: number;
  protected maxHealth: number;
  protected isActive: boolean;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    this.health = 1;
    this.maxHealth = 1;
    this.isActive = true;
    scene.add.existing(this);
  }

  setDifficulty(difficulty: number): void {
    this.health = this.health * difficulty;
    this.maxHealth = this.maxHealth * difficulty;
  }
  // Getters for external access
  getHealth(): number {
    return this.health;
  }

  getMaxHealth(): number {
    return this.maxHealth;
  }

  abstract override update(time: number, delta: number): void;

  takeDamage(amount: number): void {
    this.health -= amount;
    if (this.health <= 0) {
      this.health = 0;
      this.isActive = false;
      this.onDeath();
    }
  }

  heal(amount: number): void {
    this.health = Math.min(this.maxHealth, this.health + amount);
  }

  override destroy(): void {
    this.health = 0;
    super.destroy();
    this.isActive = false;
  }

  protected onDeath(): void {
    // this.destroy();
  }
} 